export enum ModalId {
  Activation,
  CoApplicant,
  CreateSavedSearch,
  EVTaxCredit,
  Geolocation,
  ManageSavedSearches,
  MoreDetails,
  SearchBar,
  SoftPull,
  WIPNotifications
}

export const ModalPriorities = {
  [ModalId.EVTaxCredit]: 2,
  [ModalId.SoftPull]: 1
};

export enum NativeModalId {
  Geolocation = 'geolocation',
  SoftPull = 'softPull'
}
